import L from "leaflet";

// Icono SVG personalizado con animación "ping"
const svgIconHtml = `
  <div class="relative flex items-center justify-center">
    <span class="animate-ping absolute inline-flex h-10 w-10 rounded-full bg-amber-500 opacity-75"></span>
    <span class="relative inline-flex">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="36" height="36">
        <path fill="#b45309" stroke="#fff" stroke-width="16"
          d="M128 252.6C128 148.4 214 64 320 64C426 64 512 148.4 512 252.6C512 371.9 391.8 514.9 341.6 569.4C329.8 582.2 310.1 582.2 298.3 569.4C248.1 514.9 127.9 371.9 127.9 252.6zM320 320C355.3 320 384 291.3 384 256C384 220.7 355.3 192 320 192C284.7 192 256 220.7 256 256C256 291.3 284.7 320 320 320z"/>
      </svg>
    </span>
  </div>
`;

const animatedIcon = L.divIcon({
  className: "custom-location-icon",
  html: svgIconHtml,
  iconSize: [40, 40],
  iconAnchor: [20, 40],
  popupAnchor: [0, -40],
});

export function initContactMap() {
  const mapDiv = document.getElementById("map");
  if (!mapDiv) return;

  // Coordenadas Balconcillo, Cusco
  const coords = [-13.510466, -71.964597];

  // Capas base
  const osm = L.tileLayer(
    "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    {
      maxZoom: 19,
      minZoom: 10,
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>',
    }
  );

  const satellite = L.tileLayer(
    "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    {
      maxZoom: 19,
      attribution:
        '&copy; <a href="https://www.esri.com/">Esri</a> &mdash; Satellite',
    }
  );

  // Inicializa el mapa con controles de capas
  const map = L.map("map", {
    center: coords,
    zoom: 16,
    scrollWheelZoom: false,
    attributionControl: false,
    layers: [osm],
  });

  // Control de capas
  L.control
    .layers(
      {
        Topographic: osm,
        Satellite: satellite,
      },
      null,
      { position: "topright", collapsed: false }
    )
    .addTo(map);

  // Marcador animado con SVG
  const marker = L.marker(coords, { icon: animatedIcon }).addTo(map);

  marker.bindPopup(`
    <div class="text-center">
      <strong>go peru now office</strong><br>
      Balconcillo<br>
      Cusco 08003<br>
      <a href="https://maps.app.goo.gl/Kw7aVSGuaz3Njpaf8" target="_blank" class="text-blue-600 underline">View on Google Maps</a>
    </div>
  `);

  marker.openPopup();

  window.addEventListener("resize", () => {
    map.invalidateSize();
  });
}

// Agrega este CSS en tu archivo de estilos para la animación
/*
.custom-location-icon .animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes ping {
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
*/


